import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  FaBars, FaCommentDots, FaTachometerAlt, FaBell,
  FaSignOutAlt, FaUserCircle, FaSun, FaMoon, FaFileAlt, FaUser, FaRobot, FaHome
} from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import './SidebarLayout.css';
import logo from '../../assets/logo2.svg'; // Adjust path as needed

const SidebarLayout = ({ children }) => {
  const { authData, setAuthData } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false); // for mobile
  const [isCollapsed, setIsCollapsed] = useState(false); // for desktop



  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
    if (window.innerWidth > 768) {
      setSidebarOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const toggleSidebar = () => {
    if (isMobile) {
      setSidebarOpen(prev => !prev); // open/close on mobile
    } else {
      setIsCollapsed(prev => !prev); // collapse/expand on desktop
    }
  };
  const { logout } = useContext(AuthContext);
  const handleLogout = () => {
    logout();            // <-- Clears authData + currentGroup correctly
    navigate('/login');  // <-- Redirect after logout
  };


  // Consume Theme Context
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className={`sidebar ${isMobile ? 'mobile' : ''} ${sidebarOpen ? 'open' : ''} ${!isMobile && isCollapsed ? 'collapsed' : ''}`}>

        {/* Sidebar header (desktop only) */}
        {!isMobile && (
          <div className="sidebar-header">
            <button className="menu-toggle" onClick={toggleSidebar}>
              <FaBars />
            </button>
            <span className="logo-text">
              <FaRobot size={40} style={{ marginRight: '4px' }} />
              AI CHATBOT
            </span>
          </div>
        )}


        <div className="profile-section">
          <FaUserCircle size={40} />
          <div className="profile-info">
            <strong>{authData?.name || 'User'}</strong>
            <small>{authData?.email}</small>
          </div>
        </div>

        <nav className="sidebar-nav">
          <Link className={location.pathname === '/chat' ? 'active' : ''} to="/chat" onClick={() => setSidebarOpen(false)}>
            <FaCommentDots size={20} /><span>{(!isMobile || sidebarOpen) && 'Chat'}</span>
          </Link>

          <Link className={location.pathname === '/profile' ? 'active' : ''} to="/profile" onClick={() => setSidebarOpen(false)}>
            <FaUser color='#007BFF' size={20} /> <span>{(!isMobile || sidebarOpen) && 'Profile'}</span>
          </Link>



          {authData?.role === 'admin' && (
            <Link className={location.pathname === '/file' ? 'active' : ''} to="/file" onClick={() => setSidebarOpen(false)}>
              <FaFileAlt color='#007BFF' size={20} /><span>{(!isMobile || sidebarOpen) && 'File Server'}</span>
            </Link>
          )}
          {authData?.role === 'admin' && (
            <Link className={location.pathname === '/dashboard' ? 'active' : ''} to="/dashboard" onClick={() => setSidebarOpen(false)}>
              <FaTachometerAlt size={20} />  <span>{(!isMobile || sidebarOpen) && 'Admin Dashboard'}</span>
            </Link>
          )}
          <Link className={location.pathname === '/' ? 'active' : ''} to="/" onClick={() => setSidebarOpen(false)}>
            <FaHome size={20} /><span>{(!isMobile || sidebarOpen) && 'Back to Home'}</span>
          </Link>
        </nav>

        <div className="sidebar-footer">
          <button className="notify-btn">
            <FaBell /> {!isMobile && <span className="badge"></span>}
          </button>
          <button onClick={handleLogout} className="logout-btn">
            <FaSignOutAlt /> {!isMobile && <span>Logout</span>}
          </button>
        </div>
        <button onClick={toggleTheme} className="theme-toggle-btn" title="Toggle Theme">
          {theme === 'dark' ? (
            <FaSun className="sun-icon" />
          ) : (
            <FaMoon className="moon-icon" />
          )}
        </button>

      </aside>

      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      {/* Main content */}
      <main className="main-content">
        <header className="main-header">
          <div className="header-left glass-logo">
            {isMobile && (
              <button className="menu-toggle mobile-toggle" onClick={toggleSidebar}>
                <FaBars />
              </button>
            )}
            <img
              src={logo}
              alt="Company Logo"
              className="company-logo clickable-logo"
              onClick={() => navigate('/chat')}
            />

          </div>

          <div className="header-right">

            <span className="welcome-msg">Welcome, {authData?.name || 'User'}!</span>


            <button onClick={handleLogout} className="logout-btn header-logout">
              <FaSignOutAlt />
              {!isMobile && <span>Logout</span>}
            </button>
          </div>
        </header>


        <div className="main-body">{children}</div>
        <footer className="main-footer">© {new Date().getFullYear()} AI IntelliDoc  - POWERED BY </footer>
      </main>
    </div>
  );
};

export default SidebarLayout;
